import { MouseEvent, useContext } from 'react';
import * as React from 'react';
import { StyledLeftButtonWithIcon } from './MobileQuickMenu.styles';
import { AjaxLinkClickProps } from 'search/AlertPanel/AlertPanel.types';
import { SearchContext } from 'search/SearchContext';
import { Icon } from '@blueprint/ui';

const createAlertText = 'Create email alert';

type Props = {
    onAjaxLinkClick?: AjaxLinkClickProps;
    trackingEventCategory: string;
    trackingEventLabel: string;
};

const CreateNotificationButton: React.FC<Props> = ({
    onAjaxLinkClick,
    trackingEventCategory,
    trackingEventLabel
}) => {
    const {
        state: {
            links: { createAlert }
        }
    } = useContext(SearchContext);

    const onClickHandler = (event: MouseEvent<HTMLElement>) => {
        onAjaxLinkClick &&
            onAjaxLinkClick(event, trackingEventCategory, trackingEventLabel);
    };

    return (
        <StyledLeftButtonWithIcon
            variant="secondary"
            isFullWidth
            data-testid="create-alert"
            onClick={onClickHandler}
            data-url={createAlert}
        >
            <Icon iconId="bell" size="medium" />
            {createAlertText}
        </StyledLeftButtonWithIcon>
    );
};

export default CreateNotificationButton;
